<template>
  <div class="wrap default">
    <div class="default_top" v-if="!content_only && top_menu">
      <div class="default_top_buttons">
        <transition name="fade" mode="out-in" appear>
          <div class="buttonsGroup">
            <slot name="buttons"></slot>
          </div>
        </transition>
        <div class="default_top_buttons_right" :class="{ two: changeStyle }">
          <transition name="fade" mode="out-in" appear>
            <ButtonChangeStyleList v-if="changeStyle && items.length && !loading" key="style" />
          </transition>
          <transition name="fade" mode="out-in" appear>
            <Pagination
              :pageData="pageData"
              v-if="pagination && items.length && !loading"
              type="limit"
              key="limit"
              :params="page_params ? page_params : undefined"
            />
          </transition>
        </div>
      </div>
      <div v-if="$slots.filters" class="default_top_filters">
        <ButtonFilterAZ
          v-if="
            $route.query.style_list === 'grid'
              ? Array.isArray(items)
                ? items.length
                : items
              : false
          "
          :sort-az="sortAz"
        />
        <slot name="filters"></slot>
      </div>
    </div>
    <transition name="fade" mode="out-in" appear>
      <LoadingAnimation v-if="loading" />
      <div
        class="default_center"
        v-else-if="!loading && Array.isArray(items) ? items.length : items"
      >
        <transition name="fade" mode="out-in" appear>
          <slot></slot>
        </transition>
      </div>
      <Plug v-else-if="!loading && Array.isArray(items) ? !items.length : !items" />
    </transition>
    <transition name="fade" mode="out-in" appear>
      <div
        v-if="
          !content_only && pagination && (Array.isArray(items) ? items.length : items) && !loading
        "
        class="default_bottom"
      >
        <Pagination
          v-if="pageData"
          :pageData="pageData"
          :params="page_params ? page_params : undefined"
          type="page"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import Pagination from 'components/Pagination'
import Plug from 'components/Plug'
import LoadingAnimation from 'components/LoadingAnimation'
import ButtonChangeStyleList from 'components/ButtonChangeStyleList'
import ButtonFilterAZ from 'components/ButtonFilterAZ'

export default {
  name: 'TemplatePageGrid',
  props: {
    sortAz: { type: String, default: 'name' },
    loading: Boolean,
    pageData: Object,
    page_params: Object,
    items: [Object, Array],
    changeStyle: Boolean,
    content_only: Boolean,
    top_menu: {
      type: Boolean,
      default: true,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ButtonFilterAZ,
    Plug,
    LoadingAnimation,
    Pagination,
    ButtonChangeStyleList,
  },
}
</script>

<style lang="scss" scoped>
.default {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
  &_top {
    display: grid;
    gap: 36px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      gap: 15px;
    }
    &_buttons {
      display: grid;
      grid-template-columns: auto max-content;
      gap: 15px;
      @media #{map-get($display-breakpoints, 'sm-and-down')} {
        grid-template-columns: 1fr;
      }
      &_right {
        width: max-content;
        @media #{map-get($display-breakpoints, 'sm-and-down')} {
          justify-self: end;
          //grid-row: 1;
        }
        &.two {
          display: grid;
          align-items: center;
          gap: 20px;
          grid-template-columns: repeat(2, max-content);
        }
      }
    }
    &_filters {
      display: grid;
      gap: 30px;
      grid-template-columns: repeat(auto-fill, 300px);
    }
  }
  :deep().buttonsGroup{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin: -10px;
    & > * {
      margin: 10px;
    }
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      margin: -5px;
      & > * {
        margin: 5px;
      }
    }
  }
  &_bottom {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
